<template>
  <g-g-app-modal
    :is-active="value"
    @close="closeModal"
    :width="$vuetify.breakpoint.mdAndUp ? '750px' : '90%'"
    :close-button-positions="['title', 'footer']"
  >
    <template v-slot:title>
      <div style="text-align: start;" class="mr-auto ml-auto">
        Powered by LiteSpeed & LSCache
        <v-icon color="primary" class="ml-3" small>mdi-checkbox-marked-circle</v-icon>
      </div>
    </template>

    <template v-slot:body>
      <v-row>
        <div style="display: flex; flex-wrap: wrap">
          <v-col cols="12" class="ma-auto">
            <v-img :src="`/static/img/wizard/litespeed-logo.png`"
                   height="140" width="140"
                   class="d-flex align-center ma-auto"/>
          </v-col>
          <v-col cols="12">
            <p class="mb-2">
              GreenGeeks websites run on LiteSpeed servers, so you can take full advantage of the LiteSpeed Cache
              website acceleration plugin. With advanced cache-management tools and optimization features. LSCache
              for WordPress is an all-in-one site acceleration solution. It's the only optimization plugin you need!
            </p>
            <p>
              Caching via LiteSpeed is activated by default so your site can employ the best practices that make
              for a high PageSpeed score, and more importantly an incredible user experience . You can disable
              this at any time from within your WP Dashboard.
            </p>
          </v-col>
        </div>
        <v-col cols="12" md="12">
          <v-row>
            <v-col cols="12" sm="6">
              <v-icon medium color="primary">mdi-clipboard-arrow-down-outline</v-icon>
              Server-Level Full-Page Cache
            </v-col>
            <v-col cols="12" sm="6">
              <v-icon medium color="primary">mdi-lock</v-icon>
              Private Cache
            </v-col>
            <v-col cols="12" sm="6">
              <v-icon medium color="primary">mdi-checkbox-blank-circle-outline</v-icon>
              Edge Side Includes (ESI)
            </v-col>
            <v-col cols="12" sm="6">
              <v-icon medium color="primary">mdi-image-size-select-actual</v-icon>
              Image Optimization
            </v-col>
            <v-col cols="12" sm="6">
              <v-icon medium color="primary">mdi-cogs</v-icon>
              Crawler
            </v-col>
            <v-col cols="12" sm="6">
              <v-icon medium color="primary">mdi-arrow-collapse-vertical</v-icon>
              CSS/JavaScript/HTML Minify
            </v-col>
            <v-col cols="12" sm="6">
              <v-icon medium color="primary">mdi-folder-outline</v-icon>
              CSS/JavaScript Combination
            </v-col>
            <v-col cols="12" sm="6">
              <v-icon medium color="primary">mdi-telegram</v-icon>
              HTTP/2 Push
            </v-col>
            <v-col cols="12" sm="6">
              <v-icon medium color="primary">mdi-cloud-download</v-icon>
              Content Delivery Network Support
            </v-col>
            <v-col cols="12" sm="6">
              <v-icon medium color="primary">mdi-file-code-outline</v-icon>
              Browser Cache Support
            </v-col>
            <v-col cols="12" sm="6">
              <v-icon medium color="primary">mdi-image-frame</v-icon>
              Lazy Load Images
            </v-col>
            <v-col cols="12" sm="6">
              <v-icon medium color="primary">mdi-database</v-icon>
              Database Optimization
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </template>
  </g-g-app-modal>
</template>
<script>
import GGAppModal from '@/components/Elements/GGAppModal.vue'

export default {
  name: 'LitespeedInfo',
  components: {
    GGAppModal,
  },
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    closeModal () {
      this.$emit('update:value', false)
    }
  }
}
</script>
